module.exports = __webpack_public_path__ + "img/cubre-palet.885e13ed.jpg";